import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, DraggableCarousel } from "../../../components/ui";
import localization from "../../../config/localization";
import Deposit from "./transactions/Deposit";
import Withdraw from "./transactions/Withdraw";
import Exchange from "./transactions/Exchange";
import Sports from "./transactions/Sports";
import Casino from "./transactions/Casino";
import Adjustments from "./transactions/Adjustments";

interface TransactionProps {
  currentTab?: string;
}

export default function Transactions({
  currentTab: initialTab,
}: TransactionProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTabId, setActiveTab] = useState(initialTab || "deposit");

  useEffect(() => {
    if (initialTab) {
      setActiveTab(initialTab);
    }
  }, [initialTab, location.pathname]);

  const tabs = [
    {
      id: "deposit",
      urlPath: "deposithistory",
      label: localization.deposit,
      component: <Deposit />,
    },
    {
      id: "withdraw",
      urlPath: "withdrawhistory",
      label: localization.withdraw,
      component: <Withdraw />,
    },
    {
      id: "exchange",
      urlPath: "exchangehistory",
      label: localization.exchange,
      component: <Exchange />,
    },
    {
      id: "sports",
      urlPath: "sportshistory",
      label: localization.sports,
      component: <Sports />,
    },
    {
      id: "casino",
      urlPath: "casinohistory",
      label: localization.casino,
      component: <Casino />,
    },
    {
      id: "adjustments",
      urlPath: "balanceAdjustment",
      label: localization.balanceAdjustment,
      component: <Adjustments />,
    },
  ];

  const onTabChange = (tab: string, urlPath?: string) => {
    navigate(`/${urlPath}`);
    setActiveTab(tab);
  };

  const activeContent = tabs.find((tab) => tab.id === activeTabId)?.component;
  const activeIndex = tabs.findIndex((tab) => tab.id === activeTabId);

  return (
    <div className="w-full lg:max-w-[95%] lg:mx-auto">
      <div className="h-9 text-white">
        <div className="px-6 py-4 lg:ml-2">
          <DraggableCarousel gap="gap-10 2xl:gap-8" activeIndex={activeIndex}>
            {tabs.map((tab) => (
              <Button
                key={tab.id}
                onClick={() => onTabChange(tab.id, tab.urlPath)}
                className="relative pb-2 text-sm md:text-base font-medium transition-colors duration-200"
              >
                <span
                  className={
                    activeTabId === tab.id ? "text-white" : "text-gray-400"
                  }
                >
                  {tab.label}
                </span>
                {activeTabId === tab.id && (
                  <span className="absolute left-[-12.5%] right-[-12.5%] bottom-0 h-0.5 bg-pink-300 rounded-full"></span>
                )}
              </Button>
            ))}
          </DraggableCarousel>
        </div>
      </div>

      {activeContent && (
        <div className="px-6 py-4 mt-2 text-white">{activeContent}</div>
      )}
    </div>
  );
}
